<template>
    <form @submit.prevent="loginSubmit">
        <h1>Logga in</h1>

        <p v-if="loginError !== null" class="flash-error">
            {{ loginError }}
        </p>

        <p class="form-group">
            <label for="login_username">Användarnamn</label>
            <input type="text" v-model="credentials.username" id="login_username">
        </p>
        <p class="form-group">
            <label for="login_password">Lösenord</label>
            <input type="password" v-model="credentials.password" id="login_password">
        </p>

        <p>
            <button type="submit">Logga in</button>
        </p>
    </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { catchApiError } from '../http'

export default {
    name: 'login',
    data: function () {
        return {
            credentials: {
                username: '',
                password: '',
            },
            loginError: null
        };
    },
    computed: {
        ...mapState({
            authRedirect: state => state.authRedirect
        })
    },
    methods: {
        loginSubmit: function () {
            this.loginError = '';

            this.login(this.credentials)
                .then(() => {
                    this.$router.replace(this.authRedirect || '/');
                })
                .catch(err => {
                    err = catchApiError(err);

                    if (err.message) {
                        switch (err.message) {
                            case 'Invalid credentials':
                                this.loginError = 'Fel användarnamn eller lösenord.';
                                break;

                            default:
                                this.loginError = err.message;
                        }

                    } else {
                        this.loginError = 'Okänt fel';
                    }
                })
            ;
        },
        ...mapActions({
            login: 'auth/login'
        })
    }
}
</script>
